<template>
<div>
    <div v-if="versions_limit >= 0" class="fw alert alert-sm alert-info ">
        <i class="ion-information-circled mr-1"></i>
        <b>Up to {{ versions_limit+1 }} file versions are stored.</b>
        Upgrade your account for unlimited versions.
    </div>

    <i v-if="versions === null" class="ion-load-c spin"></i>

    <template v-else>
        <!-- Table that shows in the file row panel, on desktop and tablet -->
        <table class="table mx-auto" id="fileversions-table" style="width: fit-content">
            <thead>
                <th class="text-center width-0">Version</th>
                <th class="text-center">Uploaded By</th>
                <th class="width-0" v-if="!disable_download">Actions</th>
            </thead>
            <tbody>
                <tr v-for="(version, idx) in versions" :key="version.id">
                    <td class="text-center">
                        <span class="badge" :class="idx == 0 ? 'badge-primary' : 'badge-light'">{{version.version_number}}</span>
                        <div class="text-sm">{{ version.size | format_bytes }}</div>
                    </td>
                    
                    <td class="text-center text-sm">
                        <modified-box 
                            v-if="team" 
                            :user-id="version.user_id" 
                            :team="team" 
                            :timestamp="version.timestamp" 
                            :external-actor="modifiedBoxExternal"
                            :hide-avatar="narrow"
                            :show-absolute-timestamp="true"
                        />
                    </td>
                    <td class="d-flex" v-if="!disable_download">
                        <button v-if="file.viewer" class="btn text-sm btn-flat" :class="[file.viewer.btn_class]" @click.prevent="preview_version(version)" :disabled="disable_download">
                            {{ file.viewer.verb }} <i class="icon-lg ml-2" :class="file.viewer.icon_class"></i>
                        </button>

                        <button class="btn text-sm btn-sm" @click="download_version(version)"  :disabled="file.loading || disable_download">
                            <span class="mr-2" v-if="!narrow">Download</span>
                            <i :class="{'ion-arrow-down-a': !file.loading, 'ion-load-c spin': file.loading}" class="icon-lg"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </template>
</div>
</template>
<script>

import { FileVersionService } from '@/services/fileversion-service.js'
import { useResponsive } from '@/helpers/useResponsive';
import modifiedBox from './modified-box.vue';
import { Utils } from '@/helpers/utils'
import { bus, events } from '@/helpers/event_bus';

export default {

    props: {
        file: Object,
        user: Object,
        modifiedBoxExternal: [Object, null],
        disable_download: {
            type: Boolean,
            default: false
        },
        // Set to True if the view should always be optimized for narrow container, regardless of the window width (e.g., in a modal)
        force_narrow: {
            type: Boolean,
            default: false
        }
    },

    components: {
        modifiedBox
    },

    data(){
        return {
            versions: null
        }
    },

    computed: {
        team(){
            return this.user?.team || []
        },
        versions_limit(){
            return this.user?.team_settings?.config?.versioning_keep_versions || -1
        },

        narrow(){ return this.force_narrow || useResponsive().isMobile }
    },

    created(){
        if(!this.versions){
            FileVersionService.get_file_history(this.file.id).then(res => {
                // Make sure the versions are sorted by ID (descending) before the version number is calculated
                let versions = Utils.sortByKeys(res.body, 'id', true)
                // Assign verssion number
                versions.forEach((version, idx) => version.version_number = `v${versions.length - idx}`)
                this.versions = versions
                this.$emit('versions_num', versions.length)
            })
        }
    },

    methods: {
        
        preview_version(version) {
            if(this.disable_download) return

            const file = this.file
            file.version_id = version.id

            // Pass the different versions of the same file as the file list to the preview modal, 
            // so the user can cycle through the versions
            const previewable_files = this.versions.map(v => {
                let f = structuredClone(file)
                f.version_id = v.id // To download the correct version
                f.version_number = v.version_number // To display in the file list
                return f
            })
            bus.$emit(events.OPEN_FILE_VIEWER, { file, previewable_files })
        },

        download_version(version){
            const file = this.file
            const version_id = version.id
            bus.$emit(events.DOWNLOAD_FILE, {file, version_id})
        }
    }
}
</script>
<style scoped>

thead th{
    text-align: center
}

.version-header{
    border-bottom: 1px solid #ebebeb
}
.version-details{
    line-height: 2em
}
</style>
